export const chargingSessionTableHeaders = [
  {
    Header: "S.No",
  },
  {
    Header: "Charger ID",
  },
  {
    Header: "Origin",
  },
  {
    Header: "Source",
  },
  {
    Header: "Session Id",
  },
  {
    Header: "Status",
  },
  {
    Header: "Start Time",
  },
  {
    Header: "End Time",
  },
  {
    Header: "No of Units Dispatched",
  },
  {
    Header: "Total Amount",
  },
];
